import classNames from 'classnames';

import styles from './Arrow.module.css';

import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export type ArrowDirection = 'up' | 'down' | 'left' | 'right';
export interface ArrowProps extends IconProps {
  /** The direction of the arrow. */
  arrowDirection?: ArrowDirection;
}

export function Arrow(props: ArrowProps) {
  const { arrowDirection = 'up', className, ...iconProps } = props;
  const cssClass = classNames(className, styles[arrowDirection]);
  return (
    <IconSvg {...iconProps} className={cssClass} viewBox="0 0 12 20">
      <path d="M11.03 19.53a.75.75 0 00.073-.976l-.073-.084-8.467-8.468 8.467-8.469a.75.75 0 00.073-.976L11.03.472A.75.75 0 0010.054.4L9.97.473.972 9.471a.75.75 0 00-.072.977l.072.084L9.97 19.53a.749.749 0 001.06 0z"></path>
    </IconSvg>
  );
}
